export default __webpack_public_path__ + "static/BannerProduct2-ec51937ec003c0e35007026d5a07a8a2.jpg";